<template>

  <div class="base">
  
    <!-- <div class="pesquisa">
    <label> Procurar por:</label><input class="form-control" v-model="searchTerm" />
    </div> -->

   <TableLite
   :is-static-mode="true"
    :columns="columns"
    :rows="rows"
    :total="totalRecordCount"
    :sortable="sortable"
   />

  </div>
</template>

<script>
import TableLite from '../../../components/Tables/Table-Simple.vue'
import {GetDataAllMateria } from "../../../controllers/Materia-Prima/GetDataAllMateria"
export default {
components : { TableLite },
async created(){
  const res = await GetDataAllMateria();
  if(res){
    this.data = res.data.list
  }

},
data(){
  return {
   isLoading : false,
   searchTerm : "",
   columns : [
     
     {
       label : "Código Matéria Prima",
       field : "codigo_materia_prima",
       width : "8%",
       sortable : true
     },
     {
     label : "Descrição",
     field : "descricao",
     width : "12%",
     sortable : true,
     isKey : true,
     },
   ],


   data : [],

   sortable : {
     order : "id",
     sort : "asc"
   },
   }
   },
   computed : {

     totalRecordCount(){

       return this.rows.length;
     },

      rows() {
        return this.data.filter( (x) =>
            x.descricao.includes(this.searchTerm)
        );
      }
      

   }

}
</script>

<style scoped>

.table td,
.table th {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 1px solid var(--cinza);
}

.form-control{
    display: block;
    width: 240px;
    height: calc(1.5em + 0.75rem + 2px);
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--inputColor);
    background-color: var(--white);
    background-clip: padding-box;
    border: 1px solid var(--greyBtn);
    border-radius: 0.35rem;
    transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

.base{
    padding: 15px;
    /* background: #fff; */
    border-radius: 15px;
}

.pesquisa{
  
    /* text-align: left; */
    display: flex;
    justify-content: end;
    align-items: center;
}





</style>
